export default {
  INSURED_PERSON: "VZ",
  POLICYHOLDER: "VP",
};
